import { render, staticRenderFns } from "./SliderElement.vue?vue&type=template&id=565d976a"
import script from "./SliderElement.ts?vue&type=script&lang=ts&external"
export * from "./SliderElement.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports